import { render, staticRenderFns } from "./NoMenu.vue?vue&type=template&id=7c3cf45c&"
import script from "./NoMenu.vue?vue&type=script&lang=js&"
export * from "./NoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports